//获取当前设备是否企微
export const device=()=>{
    var ua = navigator.userAgent.toLowerCase();
    return ua.indexOf("micromessenger") != -1;
    // return true;
}